import { MapPin, Clock } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
const hoursData = [{
  day: "Monday",
  hours: "7:00 AM - 5:00 PM"
}, {
  day: "Tuesday",
  hours: "7:00 AM - 5:00 PM"
}, {
  day: "Wednesday",
  hours: "7:00 AM - 5:00 PM"
}, {
  day: "Thursday",
  hours: "7:00 AM - 5:00 PM"
}, {
  day: "Friday",
  hours: "7:00 AM - 5:00 PM"
}, {
  day: "Saturday",
  hours: "8:00 AM - 12:00 PM"
}, {
  day: "Sunday",
  hours: "Closed"
}];
export default function OperationalHours() {
  return <section data-section-id="134048" id="swan-hill-distribution" className="bg-background py-24 text-foreground">
      <div className="mx-auto max-w-4xl px-4">
        <div className="mb-12 text-center">
          <h2 className="text-foreground text-[50px] font-bold leading-tight font-serif tracking-tighter uppercase">
            Wholesale Operating Hours
          </h2>
        </div>

        <div className="border-border overflow-hidden border bg-card shadow-md rounded-sm">
          <Table>
            <TableHeader>
              <TableRow className="hover:bg-transparent border-b-2 border-border bg-primary">
                <TableHead className="text-primary-foreground w-1/2 px-8 py-6 text-lg font-bold uppercase tracking-wider">
                  <div className="flex items-center gap-2">
                    <Clock className="text-ring h-5 w-5" />
                    Trading Day
                  </div>
                </TableHead>
                <TableHead className="text-primary-foreground w-1/2 px-8 py-6 text-lg font-bold uppercase tracking-wider">
                  Supply Hours
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {hoursData.map((item, i) => <TableRow key={item.day} data-index={i} className="border-border even:bg-muted/30 odd:bg-card hover:even:bg-muted/30 hover:odd:bg-card transition-none">
                  <TableCell className="text-foreground px-8 py-5 text-base font-semibold font-sans">
                    {item.day}
                  </TableCell>
                  <TableCell className="text-secondary px-8 py-5 text-base font-sans">
                    {item.hours}
                  </TableCell>
                </TableRow>)}
              <TableRow className="bg-primary hover:bg-primary border-0 transition-none">
                <TableCell colSpan={2} className="px-8 py-6">
                  <div className="flex items-center justify-center gap-3 text-center">
                    <MapPin className="h-6 w-6 text-ring" />
                    <span className="text-lg font-medium text-primary-foreground font-mono">
                      31-33 Beveridge St, Swan Hill VIC 3585, Australia
                    </span>
                  </div>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      </div>
    </section>;
}